import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart';
import type { ActivityPoint } from '@/types/analytics';
import { formatShortDate } from '@/lib/analytics-format';

interface ActivityLineChartProps {
  data: ActivityPoint[];
}

const chartConfig: ChartConfig = {
  done: { label: 'Done', theme: { light: 'var(--chart-1)', dark: 'var(--chart-1)' } },
  skipped: { label: 'Skipped', theme: { light: 'var(--chart-3)', dark: 'var(--chart-3)' } },
  pending: { label: 'Pending', theme: { light: 'var(--chart-4)', dark: 'var(--chart-4)' } },
  reminded: { label: 'Reminded', theme: { light: 'var(--chart-5)', dark: 'var(--chart-5)' } },
};

export function ActivityLineChart({ data }: ActivityLineChartProps) {
  const points = data.map((d) => ({ ...d, label: formatShortDate(d.bucket) }));
  return (
    <ChartContainer config={chartConfig} className="h-[240px] w-full">
      <AreaChart data={points} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis dataKey="label" tickLine={false} axisLine={false} fontSize={11} />
        <YAxis tickLine={false} axisLine={false} fontSize={11} allowDecimals={false} />
        <ChartTooltip content={<ChartTooltipContent indicator="dot" />} />
        <ChartLegend content={<ChartLegendContent />} />
        <Area
          type="monotone"
          dataKey="done"
          stackId="1"
          stroke="var(--color-done)"
          fill="var(--color-done)"
          fillOpacity={0.4}
        />
        <Area
          type="monotone"
          dataKey="skipped"
          stackId="1"
          stroke="var(--color-skipped)"
          fill="var(--color-skipped)"
          fillOpacity={0.4}
        />
        <Area
          type="monotone"
          dataKey="pending"
          stackId="1"
          stroke="var(--color-pending)"
          fill="var(--color-pending)"
          fillOpacity={0.3}
        />
        <Area
          type="monotone"
          dataKey="reminded"
          stackId="1"
          stroke="var(--color-reminded)"
          fill="var(--color-reminded)"
          fillOpacity={0.3}
        />
      </AreaChart>
    </ChartContainer>
  );
}
